import { useEffect, useState } from "react";
import { fetchRuntimeConfig } from "../api";
import logger from "../logger";
export const useRuntimeConfig = () => {
    const [config, setConfig] = useState({});
    useEffect(() => {
        fetchRuntimeConfig()
            .then(setConfig)
            // Failures are swallowed on purpose, because analytics is optional and
            // shouldn't break the app.
            .catch((e) => logger.warn("No runtime config", e));
    }, []);
    return config;
};
